export const formatMonetaryValue = (monetaryValue: string | number) => {
  if (typeof monetaryValue === 'string') {
    monetaryValue = parseFloat(monetaryValue);
  }

  const fraction = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'EUR'
  });

  //string replace: use regular space instead of a non-breaking space.
  return fraction.format(monetaryValue).replace(/\u00A0/g, ' ');
};
